export default __webpack_public_path__ + "static/media/folder-plus.7b54ab82.svg";